/**
 * Basic filter model.
 *
 */
class FilterItemModel {
  constructor(id, title, filterGroup, count, reversed) {
    this.id = id;
    this.title = title;
    this.filterGroup = filterGroup;
    this.count = count;

    // Reverse checking and unchecking mechanism
    // Zo check if not in URL, uncheck if inside url
    this.reversed = reversed;
  }
}

export default FilterItemModel;
